import React from "react";
import { Link } from "react-router-dom";

export default function ContactLink({ children, className, onOpen }) {
    const handleClick = (e) => {
        e.preventDefault();

        // Try event dispatch (both targets)
        const evt = new Event("open-contacts");
        window.dispatchEvent(evt);
        document.dispatchEvent(evt);

        // Fallback to imperative opener if available
        if (typeof window.__openContacts === "function") {
            window.__openContacts();
        }

        onOpen?.();
    };

    return (
        <Link to="#" onClick={handleClick} className={className}>
            {children}
        </Link>
    );
}
